import { postData } from './http';
import { getRootPath } from './rootPath';

const apiUrl = 'website/language';

export function setLanguage(lang: string, id: string): Promise<{}> {
    return postData(`${getRootPath()}${apiUrl}/setlanguage`,
        { language: lang, domainid: id },
        { logErrors: false });
}
